import once from '@lib/once';
import isDesktop from '@lib/is-desktop';
import { insertIcons } from '@lib/icon';

function createTextSpan(text) {
    const span = document.createElement('span');
    span.innerText = text;
    return span;
}

function createIcon(icon, classes = []) {
    if (!Array.isArray(classes)) classes = [classes];
    const span = document.createElement('span');
    span.classList.add('icon', ...classes);
    span.dataset.icon = icon;
    return span;
}

function createBtn({ text, icon, click }) {
    const btn = document.createElement('button');
    btn.classList.add('button', 'button--text', 'has-lightblue-icon');
    btn.type = 'button';
    btn.appendChild(text);
    btn.appendChild(icon);
    btn.addEventListener('click', click);
    btn.style.display = 'none';
    return btn;
}

function initMobileCollapsibleText(el) {
    el.style.overflow = 'hidden';
    el.style.display = 'block';

    let expanded = el.dataset.expanded === 'true';

    const expandBtn = createBtn({
        text: createTextSpan(el.dataset.expandText),
        icon: createIcon('chevron-down'),
        click: toggle,
    });
    const collapseButton = createBtn({
        text: createTextSpan(el.dataset.collapseText),
        icon: createIcon('chevron-down', 'icon--rotate-180'),
        click: toggle,
    });

    const buttons = document.createElement('div');
    buttons.classList.add('buttons', 'mb-1');
    buttons.append(expandBtn);
    buttons.append(collapseButton);

    insertIcons(buttons);
    el.parentNode.insertBefore(buttons, el.nextSibling);

    window.addEventListener('resize', onResize, { passive: true });
    update();

    function update() {
        const maxHeight = Math.floor(window.innerHeight * 0.5);
        if (el.scrollHeight > maxHeight && !isDesktop()) {
            el.style.height = (expanded ? el.scrollHeight : maxHeight) + 'px';
            el.dataset.expanded = expanded.toString();
            if (expanded) {
                expandBtn.style.display = 'none';
                collapseButton.style.removeProperty('display');
            } else {
                expandBtn.style.removeProperty('display');
                collapseButton.style.display = 'none';
            }
        } else {
            el.style.removeProperty('height');
            el.dataset.expanded = 'false';
            expandBtn.style.display = 'none';
            collapseButton.style.display = 'none';
        }
    }

    function onResize() {
        el.style.removeProperty('height');
        update();
    }

    function toggle() {
        expanded = !expanded;
        update();
    }
}

window.Drupal.behaviors.mobileCollapsibleText = {
    attach: (context) => {
        context.querySelectorAll('[data-mobile-collapsible-text]').forEach((el) => {
            once('mobile-collapsible-text', initMobileCollapsibleText, [el]);
        });
    },
};
